import React, { createContext, useState, useEffect } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import SlideLeft from "@components/atoms/SlideLeft/SlideLeft";
import { useLocation } from "react-router-dom";
interface IGlobalAlertContext {
  setGlobalAlertMessage: React.Dispatch<string>;
  setGlobalAlertSeverity: React.Dispatch<AlertColor>;
  showGlobalAlert: () => void;
  hiddenGlobalAlert: () => void;
}
export const GlobalAlertContext = createContext(({} as IGlobalAlertContext));
const GlobalAlertProvider = ({
  children
}: any) => {
  const location = useLocation();
  const [globalAlertMessage, setGlobalAlertMessage] = useState("Error");
  const [openGlobalAlert, setOpenGlobalAlert] = useState(false);
  const [globalAlertSeverity, setGlobalAlertSeverity] = useState<AlertColor>("error");
  const handleOpen = () => {
    if (openGlobalAlert) {
      setOpenGlobalAlert(false);
      return setTimeout(() => {
        setOpenGlobalAlert(true);
      }, 300);
    }
    setOpenGlobalAlert(true);
  };
  const handleClose = () => setOpenGlobalAlert(false);
  useEffect(() => {
    if (!location.state?.showAlert) {
      handleClose();
    }
  }, [location]);
  return <GlobalAlertContext.Provider value={{
    setGlobalAlertMessage,
    setGlobalAlertSeverity,
    showGlobalAlert: handleOpen,
    hiddenGlobalAlert: handleClose
  }}>
      {children}
      <Snackbar open={openGlobalAlert} autoHideDuration={6000} TransitionComponent={SlideLeft} anchorOrigin={{
      vertical: "top",
      horizontal: "right"
    }} sx={{
      position: "absolute",
      zIndex: 1000
    }}>
        <Alert onClose={handleClose} severity={globalAlertSeverity} sx={{
        position: "relative",
        bottom: 10
      }}>
          {globalAlertMessage}
        </Alert>
      </Snackbar>
    </GlobalAlertContext.Provider>;
};
export default GlobalAlertProvider;